import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ct-form',
  templateUrl: './ct-form.component.html',
  styleUrls: ['./ct-form.component.css']
})
export class CtFormComponent implements OnInit {

  title = "Correspondance Tracking";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/correspondance-tracking/ct-form/ct-form.component.ts